import { Button } from "reactstrap";
import { IFHL, IRack } from "../../globals/interfaces";
import Card from "../custom/Card";
import MawbInput from "../custom/MawbInput";
import useTypedForm from "../custom/hookForm/useTypedForm";
import { useEffect } from "react";
import apiClient from "../../apiClient";
import { getTsDate, notify, yupMawbValidator } from "../../utils";
import { FormGroup } from "reactstrap";
import { Label } from "reactstrap";
import * as yup from 'yup';
import { yupResolver } from "@hookform/resolvers/yup";
import { useAppContext } from "../../context";

export default function FhlManualEntry () {

    const { user } = useAppContext();

    const {
        formState: {
            errors,
            isDirty,
            isValid
        },
        handleSubmit,
        trigger,
        reset,
        watch,
        setValue,
        FormInput
    } = useTypedForm<IFHL>({
        mode: 'all',
        resolver: yupResolver(fhlSchema)
    });

    const resetForm = () => {
        reset({
            s_mawb: '',
            t_created: getTsDate(),
            s_created_by: user.s_email,
            t_modified: getTsDate(),
            s_modified_by: user.s_email
        });
    }

    useEffect(() => {
        resetForm();
    }, []);

    const mawb = watch('s_mawb');
    const setMawb = (value: string) => {
        setValue('s_mawb', value, {
            shouldTouch: true,
            shouldValidate: true
        });
    }

    const submit = async (values: IFHL) => {
        try {
            values.s_hawb = values.s_hawb.trim();
            await apiClient.post('/manualEntryFhl', values);
            notify('FHL Created');
            setValue('s_mawb', '', {
                shouldTouch: true,
                shouldValidate: true
            });
            resetForm();
        } catch (err) {
            alert(err);
        }
    }

    return (
        <Card>
            <div>
                <FormGroup>
                    <Label>MAWB</Label>
                    <MawbInput 
                        value={mawb}
                        onChange={setMawb}
                    />
                </FormGroup>
                <FormInput name={'s_hawb'} label='HAWB' />
                <FormInput name={'f_weight'} type='number' label='Weight' />
                <FormInput name={'i_pieces'} type='number' label='Pieces' />
                <FormInput name={'s_origin'} label='Origin' />
                <FormInput name={'s_destination'} label='Destination' />
                <FormInput name={'s_mawb_origin'} label='MAWB Origin' />
                <FormInput name={'s_mawb_destination'} label='MAWB Destination' />
                <Button 
                    onClick={handleSubmit(submit)}
                    disabled={!isValid}
                >
                        Submit
                </Button>
            </div>
        </Card>
    );
}

const fhlSchema = yup.object().shape({
    s_mawb: yupMawbValidator,
    s_hawb: yup.string().required(),
    f_weight: yup.string().required(),
    i_pieces: yup.string().required(),
    s_origin: yup.string().required().length(3, 'must be 3 characters'),
    s_destination: yup.string().required().length(3, 'must be 3 characters'),
    s_mawb_origin: yup.string().required().length(3, 'must be 3 characters'),
    s_mawb_destination: yup.string().required().length(3, 'must be 3 characters'),
});